<template>
  <el-dialog
    top="0"
    class="dialog-full-medium"
    width="30%"
    title=""
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <div class="dialog__body">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="差错处理类型" prop="mistakeType">
          <jr-select
            v-model="form.mistakeType"
            placeholder="请选择"
            :size="formSize"
            dictionary-type="COUNT_YIBAO_ERROR"
            select-style="max-width: 180px;"
            :hasAll="false"
            :disabled="isModify"
            @change="selectChange"
          />
        </el-form-item>
        <el-form-item label="" class="content">
          {{text}}
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button @click="handleClose()" :size="formSize">{{isModify ? '关闭' : '取消'}}</el-button>
      <el-button
        v-if="!isModify"
        type="primary"
        :size="formSize"
        @click="submit()"
        :loading="submitLoading"
      >
        提交处理
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateDiff } from '@/api/counting';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    fileType: {
      type: String,
      default: '',
    },
    isModify: {
      type: Boolean,
      default: false,
    },
    currentObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      submitLoading: false,
      form: {
        mistakeType: '',
        mistakeNo: '',
      },
      rules: {
        mistakeType: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      text: '',
    };
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.submitLoading = false;
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.text = '';
        const { mistakeType = '', mistakeNo = '' } = this.currentObj;
        this.form.mistakeType = mistakeType;
        this.form.mistakeNo = mistakeNo;
        if (this.isModify) {
          this.selectChange(mistakeType);
        } else {
          this.$refs.form.resetFields();
        }
      });
    },
    // 提交
    async submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const params = {
              ...this.form,
              remark: this.text,
              fileType: this.fileType,
              type: 1,
            };
            this.submitLoading = true;
            await updateDiff(params);
            this.$message.success('处理成功！！');
            this.submitLoading = false;
            this.handleClose();
            this.$emit('success');
          } catch (error) {
            console.log(error);
            this.submitLoading = false;
          }
        }
      });
    },
    selectChange(val) {
      const type = {
        test: '测试数据导致该条数据产生，可忽略', // 测试数据
        unilateral: '通知运营人员确认数据源', // 单边无数据
        bilateral: '通知运营人员确认数据源', // 双边数据存在差异
      };
      this.text = type[val];
    },
  },

};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    min-width: 500px;
    .el-dialog__footer {
      text-align: center;
    }
  }
  .content {
    .el-form-item__content {
      margin-left: 25px !important;
    }
  }
}
</style>
